'use client';

import {
    Alert,
    AlertState,
    Box,
    BoxContent,
    Button,
    Columns,
    ColumnsItem,
    Image,
    Price,
    Sticker,
    Text,
    TextLevels,
    TextMarkup,
    TrilogyColor,
    TypographyBold,
    View,
} from '@bytel/trilogy-react-ts';

import { RepeaterProduct } from '@app-types/product';

import { MEDIA_BASE_URL } from '@helpers/config';

import { useHome } from '@landing/hooks';

interface BboxOtisOptionProps {
    onClick: () => void;
    onAddOtisRepeater: () => void;
    shouldShowAlert: boolean;
    repeater: RepeaterProduct;
}

export default function BboxOtisOption({
    onClick,
    onAddOtisRepeater,
    shouldShowAlert,
    repeater,
}: Readonly<BboxOtisOptionProps>) {
    const { selectedFaiOption } = useHome();

    return (
        <View className='option-otis'>
            <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} level={TextLevels.ONE}>
                En option&nbsp;:&nbsp;le WiFi à tous les étages
            </Text>
            <Alert
                alert={AlertState.WARNING}
                display={shouldShowAlert}
                title="Ajoutez d'abord l'offre Pure Fibre"
                description="L'option répéteur WiFi est seulement compatible avec une offre Pure Fibre. Ajoutez-en une pour continuer !"
            />

            <Box className='custom-box'>
                <BoxContent background={TrilogyColor.SECONDARY20} className='is-paddingless'>
                    <Columns mobile centered verticalCentered className='is-gapless'>
                        <ColumnsItem narrow className='box-img-container'>
                            <Image
                                src={repeater.imgRepeater?.public_url || `${MEDIA_BASE_URL}/Repeteur.webp`}
                                alt='Box'
                                width={80}
                                height={100}
                            />
                        </ColumnsItem>

                        <ColumnsItem className='has-background-white'>
                            <View className='has-custom-padding has-text-tertiary-60'>
                                {repeater.promoLabel && (
                                    <Sticker variant={TrilogyColor.PRIMARY} small className='mb-2'>
                                        {repeater.promoLabel}
                                    </Sticker>
                                )}
                                <Columns verticalCentered className=''>
                                    <ColumnsItem className='pr-0'>
                                        <Columns multiline mobile marginless verticalCentered className='gap-small'>
                                            <ColumnsItem className='is-paddingless' narrow>
                                                <Text
                                                    marginless
                                                    typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}
                                                    level={TextLevels.ONE}
                                                >
                                                    {repeater.name || 'Répéteur WiFi'}
                                                </Text>
                                            </ColumnsItem>
                                            <ColumnsItem narrow className='is-paddingless'>
                                                <Text level={TextLevels.TWO} markup={TextMarkup.SPAN}>
                                                    &nbsp;+
                                                    <Price
                                                        className='normal-weight'
                                                        amount={repeater.prices.final}
                                                        inline
                                                        period='mois'
                                                    />
                                                </Text>
                                            </ColumnsItem>
                                        </Columns>
                                        <Text marginless level={TextLevels.TWO}>
                                            {repeater.shortDescription || 'Idéal pour les logements de plus de 80 m²'}
                                        </Text>
                                        <a onClick={onClick} className='button-clear link has-text-blue-byou'>
                                            {repeater.textLink || 'Ai-je besoin d‘un répéteur ?'}
                                        </a>
                                    </ColumnsItem>
                                    <ColumnsItem narrow>
                                        <Button
                                            variant={selectedFaiOption ? TrilogyColor.TERTIARY : TrilogyColor.PRIMARY}
                                            className={`is-block ${selectedFaiOption ? '' : 'has-byou-background'}`}
                                            onClick={onAddOtisRepeater}
                                        >
                                            {selectedFaiOption ? 'Retirer du panier' : 'Ajouter au panier'}
                                        </Button>
                                    </ColumnsItem>
                                </Columns>
                            </View>
                        </ColumnsItem>
                    </Columns>
                </BoxContent>
            </Box>
        </View>
    );
}
